
const formatString = 'YYYYMMDD_HHmmss';
const verifyTfs = /\d{8,}_\d{6,}/;

export const isTFS = (timecode) => {
    return verifyTfs.test(timecode);
};

export const tfsToDate = (timecode) => {
    const year = timecode.substring(0,4);
    const monthIndex = parseInt(timecode.substring(4,6)) - 1;
    const day = timecode.substring(6,8);
    const hour = timecode.substring(9,11);
    const minute = timecode.substring(11,13);
    const second = timecode.substring(13);
    const date = new Date(year, monthIndex, day, hour, minute, second);
    return date;
};

export const dateToTimecode = (dateString) => {
    const date = new Date(dateString);
    const year = (date.getFullYear()).toString();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = (date.getDate()).toString().padStart(2, '0');
    const hour = (date.getHours()).toString().padStart(2, '0');
    const minute = (date.getMinutes()).toString().padStart(2, '0');
    const second = (date.getSeconds()).toString().padStart(2, '0');

    const timecode = year + month + day + '_' + hour + minute + second;
    return timecode;
};
